module.exports = __webpack_public_path__ + "assets/czech.dcdafd5c211c33f1e7de44d33c92dbcc.svg?";